import type { Messages } from "../catalogue.en";

/**
 * Patients: the registry and the patient card.
 *
 * Composed into the public catalogue by `catalogue.ru.ts`. Nothing imports
 * this module directly: consumers ask the catalogue, so how the messages are
 * stored stays this layer's business.
 */
export const patients: Partial<Messages> = {
  "patient.documents.nationalType": "Вид документа по справочнику",
  "patient.documents.nationalPolicyType": "Вид полиса по справочнику",
  "patient.documents.insurerCoding": "Страховщик по справочнику",
  "patient.documents.searchCoding": "Поиск в справочнике профиля клиники",
  "patient.documents.clearCoding": "Убрать привязку к справочнику",



  "patient.curator.edit": "Изменить куратора",
  "patient.curator.title": "Куратор",
  "patient.curator.none": "Куратор не назначен",
  "patient.curator.loading": "Загрузка куратора",
  "patient.curator.notFound": "Пациент не найден.",
  "patient.curator.unsaved": "Несохранённое назначение куратора",
  "patient.curator.cycle":
    "Это назначение создаст замкнутую цепочку кураторов.",
  "patient.curator.ineligible":
    "Куратором может быть только действующий врач этой клиники.",
  "patient.curator.stale":
    "Куратор изменён в другой сессии. Загрузите текущее назначение.",
  "patient.curator.failed":
    "Не удалось загрузить или сохранить куратора. Повторите попытку.",

  "patients.title": "Пациенты",
  "patients.loading": "Загрузка пациентов",
  "patients.tableLabel": "Реестр пациентов",
  "patients.resultCountOne": "{count} пациент",
  "patients.resultCountMany": "Пациентов: {count}",
  "patients.matchCountOne": "{count} подходящий пациент",
  "patients.matchCountMany": "Подходящих пациентов: {count}",
  "patients.columnPatient": "Пациент",
  "patients.columnCode": "Код",
  "patients.columnBirthDate": "Дата рождения",
  "patients.columnSex": "Пол",
  "patients.columnStatus": "Статус",
  "patients.columnUpdated": "Обновлено",
  "patients.columnExternalSystems": "Внешние системы",
  "patients.columnAcquisition": "Привлечение",
  "patients.filterTestPatients": "Тестовые пациенты",
  "patients.filterRealPatients": "Реальные пациенты",
  "patients.filterVipPatients": "VIP-пациенты",
  "patients.filterRegularPatients": "Обычные пациенты",
  "patients.filterKindGroup": "Тип записи",
  "patients.filterVipGroup": "VIP-статус",
  "patients.birthFrom": "Дата рождения с",
  "patients.birthTo": "Дата рождения по",
  "patients.updatedFrom": "Обновлено с",
  "patients.updatedTo": "Обновлено по",
  "patients.columnActions": "Действия",
  "patients.cardNamed": "Открыть карту пациента {name}, {code}",
  "patients.selectNamed": "Выбрать {name}, {code}",
  "patients.matchedFormerName": "Совпадение по прежнему имени",
  "patients.selectedPatient": "Выбранный пациент",
  "patients.openCard": "Открыть карту пациента",
  "patients.empty": "Пациентов пока нет",
  "patients.emptyDetail":
    "Здесь будут отображаться пациенты, зарегистрированные в этой клинике.",
  "patients.birthDateInvalid":
    "Указанная дата рождения не является действительной календарной датой.",
  "patients.criterionRefused":
    "Сервер отклонил одно из этих поисковых выражений. Измените его, чтобы список загрузился.",
  "patients.noMatches": "Ни один пациент не соответствует этим фильтрам",
  "patients.noMatchesDetail":
    "Измените фильтры столбцов или очистите их, чтобы увидеть всех.",
  "patients.loadFailed": "Не удалось загрузить пациентов",

  "patient.code": "Код пациента",
  "patient.birthDate": "Дата рождения",
  "patient.acquisition": "Источник привлечения",
  "patient.acquisition.kind.clinic": "Клиника",
  "patient.acquisition.kind.practitioner": "Специалист",
  "patient.acquisition.kind.referralPartner": "Реферальный партнёр",
  "patient.acquisition.unresolved": "Старый источник не определён",
  "patient.acquisition.capture": "Способ фиксации",
  "patient.acquisition.capture.manual": "Вручную",
  "patient.acquisition.capture.onboardingLink": "Ссылка онбординга",
  "patient.acquisition.capture.module": "Внешний модуль",
  "patient.acquisition.capture.migration": "Перенос старых данных",
  "patient.acquisition.capture.correction": "Исправление",
  "patient.acquisition.option": "{kind}: {name}",
  "patient.acquisition.select": "Выберите источник",
  "patient.acquisition.loading": "Источники загружаются…",
  "patient.acquisition.loadFailed":
    "Не удалось загрузить источники привлечения.",
  "patient.acquisition.correctionReason":
    "Причина изменения источника привлечения",
  "patient.acquisition.required": "Выберите источник привлечения.",
  "patient.rowDescription": "{code}, {birth}",
  "patient.administrativeSex": "Административный пол",
  "patient.sex.female": "Женский",
  "patient.sex.male": "Мужской",
  "patient.status.active": "Активна",
  "patient.status.archived": "В архиве",
  "patient.status.merged": "Объединена",
  "patient.registration": "Регистрация",
  "patient.link.replaced-by": "Заменена на",
  "patient.link.replaces": "Заменяет",
  "patient.preferredLanguage": "Предпочитаемый язык",
  "patient.titleSheetSubtitle":
    "Гражданские и административные сведения, которые клиника хранит об этом пациенте. Клинические данные находятся в других разделах этой карты.",
  "recent.title": "Недавно открытые",
  "recent.kindPatients": "Пациенты",
  "recent.kindEncounters": "Приёмы",
  "recent.kindExternalEntries": "Внешние записи",
  "recent.openPatient": "Открыть карту {name}",
  "recent.openEncounter": "Открыть приём с {name}",
  "recent.openExternalEntry": "Открыть внешнюю запись: {name}",
  "recent.star": "Добавить {name} в избранное",
  "recent.unstar": "Удалить {name} из избранного",
  "recent.forget": "Убрать {name} из списка недавно открытых",
  "recent.ribbonTitle": "Недавно открытые пациенты",
  "recent.openCard": "Открыть записи ЭМК для {name}, {code}",
  "patient.contextLoading": "Загрузка пациента…",
  "patient.contextUnavailable": "Данные этого пациента недоступны.",
  "patient.notFound": "Пациент не найден",
  "patient.notFoundDetail": "Такого пациента в вашей клинике нет.",
  "patient.citizenship": "Гражданство",
  "patient.countryOfResidence": "Страна проживания",
  "patient.ageYears": "Возраст: {years}",
  "patient.ageYearsMonths": "Возраст: {years}, {months} мес.",
  "patient.ageMonths": "Возраст: {months} мес.",
  "patient.birthDateInvalid":
    "Эта дата рождения отклонена. Она не может быть в будущем.",
  "patient.unsavedIntent": "Данные пациента",

  // Личная отметка врача — как её ПОКАЗЫВАЕТ реестр, а не предлагает нажать.
  // Слово то же, что у действий выше («избранное»), но как факт строки.
  "patient.favouriteBadge": "Избранный пациент",
  // «VIP» остаётся латиницей: это принятое в продукте написание классификации,
  // как и в иврите.
  "patient.vipBadge": "VIP-пациент",
  // Тестовая отметка по HL7: синтетическую карту ПОМЕЧАЮТ везде, где она
  // показана, а не прячут. Одно доступное имя для чипа на всех поверхностях и
  // одно короткое слово на самом чипе — он стоит рядом с кодом в строке.
  "patient.testBadge": "Тестовый пациент",
  "patient.testChip": "ТЕСТ",
  "patientVip.mark": "Отметить как VIP",
  "patientVip.unmark": "Убрать статус VIP",
  "patientVip.staleRevision":
    "Статус VIP изменился в другом месте. Сейчас показан текущий статус; проверьте его, прежде чем менять снова.",
  "patientVip.failed": "Не удалось изменить статус VIP. Попробуйте ещё раз.",

  "patientPicker.favouriteGroup": "Избранные пациенты",
  "patientPicker.recentGroup": "Недавно просмотренные",
  "patientPicker.allGroup": "Все пациенты",
  "patientPicker.placeholder": "Пациент не выбран",
  "patientPicker.noMatches": "Нет подходящих пациентов",
  "patientPicker.loadFailed": "Не удалось загрузить пациентов.",

  "patientMerge.open": "Объединить дубликаты",
  "patientMerge.title": "Объединить дубликат пациента",
  "patientMerge.description":
    "Выбранная карта останется активной. Эта карта будет помечена как заменённая; её клиническая история останется под исходным идентификатором пациента.",
  "patientMerge.target": "Сохраняемая карта",
  "patientMerge.reason": "Примечание с причиной (необязательно)",
  "patientMerge.checkingTarget": "Проверка выбранного пациента…",
  "patientMerge.targetUnavailable": "Выбранный пациент больше недоступен.",
  "patientMerge.cancel": "Отмена",
  "patientMerge.confirm": "Объединить пациента",
  "patientMerge.merging": "Объединение…",
  "patientMerge.staleRevision":
    "Один из этих пациентов изменился. Выберите сохраняемую карту заново перед объединением.",
  "patientMerge.keyConflict":
    "Эта форма объединения уже использовалась для другого пациента. Закройте её и начните заново.",
  "patientMerge.targetNotActive":
    "Сохраняемая карта больше не активна. Выберите другого пациента.",
  "patientMerge.notFound": "Один из этих пациентов больше недоступен.",
  "patientMerge.rejected":
    "Объединение отклонено в том виде, как оно введено. Проверьте выбранного пациента и попробуйте ещё раз.",
  "patientMerge.failed": "Не удалось объединить пациентов. Попробуйте ещё раз.",

  "patientRegistration.title": "Новый пациент",
  "patientRegistration.detail":
    "Код пациента присваивается клиникой при создании карты. Всё, что здесь указано, можно изменить позже на титульном листе.",
  "patientRegistration.submit": "Зарегистрировать пациента",
  "patientRegistration.submitting": "Регистрация…",
  // Единственное место, где карта становится тестовой: сервер принимает
  // отметку только при создании и отказывает в ней при любом последующем
  // редактировании. Подсказка говорит, чем станет карта, а диалог — о том,
  // что уже не изменить, и говорит это в тот момент, когда это станет правдой.
  "patientRegistration.testPatient": "Зарегистрировать как тестового пациента",
  "patientRegistration.testPatientHint":
    "Синтетическая карта для демонстрации и проверок. Она помечена «ТЕСТ» везде, где показана.",
  "patientRegistration.testConfirmTitle": "Сохранить как тестового пациента?",
  "patientRegistration.testConfirmDetail":
    "Карта будет создана как тестовая, и снять отметку потом будет нельзя. Реального человека нужно регистрировать без неё.",
  "patientRegistration.testConfirmSave": "Сохранить как тестового",
  "patientRegistration.testConfirmFix": "Вернуться и поправить",
  "patientRegistration.unsavedDetail":
    "Это отменит пациента, которого вы вводили. Карта не создана.",
  "patientRegistration.unsavedIntent": "Новый пациент",
  "patientRegistration.keyConflict":
    "Эти данные не совпадают с пациентом, которого эта форма уже зарегистрировала. Закройте панель и откройте новую.",
  "patientRegistration.codeExhausted":
    "В этой клинике не осталось кодов пациентов. Ничего не создано; обратитесь к администратору.",
  "patientRegistration.rejected":
    "Пациент отклонён в том виде, как он введён. Проверьте поля и попробуйте ещё раз.",
  "patientRegistration.failed":
    "Не удалось зарегистрировать пациента. Попробуйте ещё раз.",

  "patientCard.workspaceLabel": "Карта пациента",
  "patientCard.menuLabel": "Разделы карты пациента",
  "patientCard.tabRecords": "Записи ЭМК",
  "patientCard.tabRecordsDescription": "Приёмы, записи и направления",
  "patientCard.tabCases": "Случаи",
  "patientCard.tabCasesDescription":
    "Эпизоды помощи, к которым относится эта работа",
  "patientCard.tabFiles": "Файлы",
  "patientCard.tabFilesDescription": "Документы и изображения",
  "patientCard.tabMessages": "Сообщения",
  "patientCard.tabMessagesDescription": "Переписка с пациентом",
  "patientCard.tabStay": "Госпитализации",
  "patientCard.tabStayDescription":
    "Плановые и зарегистрированные госпитализации",
  "patientCard.tabSchedule": "Доступность",
  "patientCard.tabScheduleDescription": "Доступность и недоступное время",
  "patientCard.tabTasks": "Задачи клиники",
  "patientCard.tabTasksDescription":
    "Открытая и завершённая работа клиники, связанная с этим пациентом",
  "patientCard.tasksTitle": "Задачи клиники",
  "patientCard.tasksEmpty": "К этому пациенту не привязано задач клиники",
  "patientCard.tasksEmptyDetail":
    "Задачи клиники, связанные с {name}, появляются здесь.",
  "patientCard.tabFinance": "Финансы",
  "patientCard.tabFinanceDescription": "Сметы лечения и данные счёта",
  "patientCard.tabLaboratory": "Результаты анализов и витальные показатели",
  "patientCard.tabLaboratoryDescription":
    "Результаты, витальные показатели, динамика и файлы отчётов",
  "patientCard.tabImaging": "Медицинские изображения",
  "patientCard.tabImagingDescription": "Размещённые исследования КТ и МРТ",
  "patientCard.tabTitleSheet": "Титульный лист",
  "patientCard.tabTitleSheetDescription": "Личные и административные сведения",
  "patientCard.tabMedical": "Медицинский титульный лист",
  "patientCard.tabMedicalDescription":
    "Диагнозы, показатели и сводка по пациенту",

  "patient.documents.previewBlank": "Предпросмотр бланка",
  "patient.documents.issueLink": "Выпустить ссылку для подписания",
  "patient.documents.sendLink": "Отправить ссылку",
  "patient.documents.deliveryFailed": "Отправка не удалась или недоступна. Скопируйте ссылку и передайте пациенту.",
  "patient.documents.deliveryQueued": "Запрошена отправка ссылки.",
  "patient.documents.sendTo": "Куда отправить",
  "patient.documents.sendAllChannels": "Во все разрешённые каналы",
  "patient.documents.noChannels": "Нет каналов, разрешённых для связи.",
  "patient.documents.linkExpires": "Истекает {when}",
  "patient.documents.linkExpired": "Срок ссылки истёк",
  "patient.documents.linkIssued": "Ссылка выпущена",
  "patient.documents.linkHidden": "Адрес показывается только при выпуске; чтобы скопировать, выпустите новую ссылку.",
  "patient.documents.noLink": "Ссылка не выпущена",
  "patient.documents.revokeReason": "Причина отзыва",
  "patient.documents.revoke": "Отозвать согласие",
  "patient.documents.uploadSigned": "Загрузить подписанное согласие",
  "patient.documents.submitReview": "Передать на проверку в клинике",
  "patient.documents.title": "Документы",
  "patient.documents.forbidden":
    "У этой учётной записи нет доступа к документам пациента.",
  "patient.documents.loading": "Загружаем документы…",
  "patient.documents.failed": "Не удалось загрузить блок документов.",
  "patient.documents.downloadFailed": "Не удалось скачать документ.",
  "patient.documents.identifierExists": "Этот идентификатор уже записан. Исправьте существующую запись или приложите к ней сканы.",
  "patient.documents.correctIdentifier": "Открыть существующую запись",
  "patient.documents.replaceIdentifierDraft": "Сбросить черновик и открыть существующую запись идентификатора? При ошибке загрузки черновик останется.",
  "patient.documents.commandFailed":
    "Не удалось выполнить действие с документом. Попробуйте ещё раз.",
  "patient.documents.downloadForbidden": "Эта учётная запись не может скачивать документы пациента.",
  "patient.documents.downloadGone": "Этот файл больше не хранится. Обновите блок.",
  "patient.documents.downloadUnavailable": "Хранилище документов не ответило. Повторите скачивание чуть позже.",
  "patient.documents.createFailed": "Не удалось создать согласие.",
  "patient.documents.issueFailed": "Не удалось выдать ссылку для подписания.",
  "patient.documents.acceptFailed": "Не удалось принять согласие.",
  "patient.documents.rejectFailed": "Не удалось отклонить согласие.",
  "patient.documents.revokeFailed": "Не удалось отозвать согласие.",
  "patient.documents.consentChanged": "Согласие изменилось, пока блок был открыт. Обновите его и повторите действие.",
  "patient.documents.consentGone": "Этого согласия больше не существует. Обновите блок.",
  "patient.documents.consentUnavailable": "Сервис согласий не ответил. Повторите чуть позже.",
  "patient.documents.consentRequestInvalid": "Запрос отклонён. Проверьте язык и причину.",
  "patient.documents.consentAlreadyActive": "У пациента уже есть действующее согласие этого вида.",
  "patient.documents.consentNotPending": "Ссылку можно выдать только согласию, ожидающему подписания.",
  "patient.documents.consentNotSubmitted": "Принять или отклонить можно только отправленное согласие.",
  "patient.documents.consentNotRevocable": "Это согласие уже отозвано или отклонено.",
  "patient.documents.consentAccepted": "Принято",
  "patient.documents.consentMissing": "Не принято",
  "patient.documents.consentLanguage": "Язык согласия",
  "patient.documents.language.en": "Английский",
  "patient.documents.language.he": "Иврит",
  "patient.documents.language.ru": "Русский",
  "patient.documents.createConsent": "Создать согласие",
  "patient.documents.creating": "Создаём…",
  "patient.documents.downloadBlank": "Скачать бланк",
  "patient.documents.downloadSigned": "Скачать подписанное согласие",
  "patient.documents.linkReady": "Ссылка для подписания",
  "patient.documents.accept": "Принять согласие",
  "patient.documents.accepting": "Принимаем…",
  "patient.documents.reject": "Отклонить",
  "patient.documents.rejecting": "Отклоняем…",
  "patient.documents.rejectReason": "Причина отклонения",
  "patient.documents.rejectTitle": "Отклонить это согласие?",
  "patient.documents.revokeTitle": "Отозвать это согласие?",
  "patient.documents.rejectionReason": "Причина отклонения",
  "patient.documents.consentSection": "Согласие на персональные данные",
  "patient.documents.governmentIds": "Паспорта и ID-документы",
  // Существительное перед числом: счёт читается без склонения, как и в
  // «Пациентов: {count}» выше.
  "patient.documents.allGovernmentIdsExpired":
    "Все документы в этом реестре истекли.",
  "patient.documents.allInsuranceExpired":
    "Все полисы в этом реестре истекли.",
  "patient.documents.insurancePolicies": "Страховые полисы",
  "patient.documents.addGovernmentId": "Добавить ID-документ",
  "patient.documents.addInsurance": "Добавить страховой полис",
  "patient.documents.noGovernmentIds": "ID-документы ещё не добавлены.",
  "patient.documents.noInsurancePolicies": "Страховые полисы ещё не добавлены.",
  "patient.documents.downloadScan": "Скачать скан",
  "patient.documents.cancel": "Отмена",
  "patient.documents.source": "Источник документа",
  "patient.documents.source.upload": "Загрузить новый скан",
  "patient.documents.source.existing": "Взять существующий файл",
  "patient.documents.pdfPage": "Страница PDF",
  "patient.documents.scanEditor": "Скан документа",
  "patient.documents.dropZone":
    "Перетащите скан сюда, вставьте его из буфера обмена или выберите файл.",
  "patient.documents.dropZoneMore":
    "Обе стороны карты или несколько страниц паспорта можно добавить отдельными изображениями — они сохранятся одним документом.",
  "patient.documents.chooseFiles": "Выбрать файлы",
  "patient.documents.addPage": "Добавить ещё страницу",
  "patient.documents.pages": "Страницы документа",
  "patient.documents.pageName": "Страница {index}",
  "patient.documents.rotateLeft": "Повернуть влево",
  "patient.documents.rotateRight": "Повернуть вправо",
  "patient.documents.cropPage": "Обрезать",
  "patient.documents.cropReset": "Сбросить обрезку",
  "patient.documents.cropMove": "Переместить рамку обрезки",
  "patient.documents.cropEdge.left": "Левый край обрезки",
  "patient.documents.cropEdge.top": "Верхний край обрезки",
  "patient.documents.cropEdge.right": "Правый край обрезки",
  "patient.documents.cropEdge.bottom": "Нижний край обрезки",
  "patient.documents.cropCorner.topLeft": "Левый верхний угол обрезки",
  "patient.documents.cropCorner.topRight": "Правый верхний угол обрезки",
  "patient.documents.cropCorner.bottomLeft": "Левый нижний угол обрезки",
  "patient.documents.cropCorner.bottomRight": "Правый нижний угол обрезки",
  "patient.documents.removePage": "Удалить страницу {index}",
  "patient.documents.movePageEarlier": "Переместить страницу {index} раньше",
  "patient.documents.movePageLater": "Переместить страницу {index} позже",
  "patient.documents.pagesMerged":
    "Страницы сохраняются отдельными файлами в этом порядке. В распознавании участвуют все файлы.",
  "patient.documents.pagePreparing": "Готовим страницу…",
  "patient.documents.pageFailed":
    "Браузер не смог подготовить страницу. Она будет загружена исходным файлом.",
  "patient.documents.unsupportedFiles": "Добавить можно только изображения и PDF-файлы.",
  "patient.documents.existingFile": "Существующий файл пациента",
  "patient.documents.selectExisting": "Выберите файл",
  "patient.documents.saving": "Сохраняем…",
  "patient.documents.saveDocument": "Сохранить документ",
  "patient.documents.suggestFromScan": "Заполнить по скану",
  "patient.documents.suggesting": "Читаем скан…",
  "patient.documents.suggestionApplied":
    "Подсказки перенесены в форму. Проверьте каждое поле перед сохранением.",
  "patient.documents.suggestionReview":
    "Автозаполнение — это только черновик. Сверьте скан и поправьте поля перед сохранением.",
  "patient.documents.recognitionUnavailable": "Распознавание документов временно недоступно. Попробуйте позже или заполните поля вручную.",
  "patient.documents.suggestionFailed":
    "Не удалось автоматически прочитать скан. Заполните поля вручную.",
  "patient.documents.suggestionWarning": "Предупреждение модели: {warning}",
  "patient.documents.previewEmpty":
    "Выберите скан, чтобы сверять его с формой.",
  "patient.documents.uploadTitle.governmentId": "Государственный ID",
  "patient.documents.uploadTitle.insurance": "Страховой полис",
  "patient.documents.governmentId.type": "Тип документа",
  "patient.documents.governmentId.type.travel_passport": "Заграничный паспорт",
  "patient.documents.governmentId.type.diplomatic_passport": "Дипломатический паспорт",
  "patient.documents.governmentId.type.service_passport": "Служебный паспорт",
  "patient.documents.governmentId.type.temporary_identity": "Временное удостоверение личности",
  "patient.documents.governmentId.type.military_id": "Военный документ",
  "patient.documents.governmentId.type.seafarer_id": "Документ моряка",
  "patient.documents.governmentId.type.stateless_document": "Документ лица без гражданства",
  "patient.documents.governmentId.type.refugee_document": "Документ беженца или убежища",
  "patient.documents.governmentId.type.snils": "СНИЛС",
  "patient.documents.governmentId.type.tax_number": "ИНН / налоговый номер",
  "patient.documents.documentSeries": "Серия",
  "patient.documents.issuerCode": "Код подразделения / выдающего органа",
  "patient.documents.personalNumber": "Личный номер",
  "patient.documents.designation": "Название документа",
  "patient.documents.governmentId.type.passport": "Паспорт",
  "patient.documents.governmentId.type.national_id_card":
    "Национальная ID-карта",
  "patient.documents.governmentId.type.residence_permit": "Вид на жительство",
  "patient.documents.governmentId.type.driving_licence":
    "Водительское удостоверение",
  "patient.documents.governmentId.type.birth_certificate":
    "Свидетельство о рождении",
  "patient.documents.governmentId.type.other_government_id":
    "Другой государственный ID",
  "patient.documents.documentNumber": "Номер документа",
  "patient.documents.issuingCountry": "Страна выдачи",
  "patient.documents.nameOnDocument": "Имя в документе",
  "patient.documents.birthDate": "Дата рождения",
  "patient.documents.issueDate": "Дата выдачи",
  "patient.documents.expiryDate": "Действует до",
  "patient.documents.issuingAuthority": "Орган выдачи",
  "patient.documents.insurance.type": "Тип полиса",
  "patient.documents.insurance.type.israel_kupat_holim_basic":
    "Израильская базовая купат-холим",
  "patient.documents.insurance.type.israel_shaban_supplementary":
    "Израильский дополнительный план ШАБАН",
  "patient.documents.insurance.type.israel_private_commercial":
    "Израильская частная коммерческая страховка",
  "patient.documents.insurance.type.israel_tourist_travel":
    "Израильская туристическая или travel-страховка",
  "patient.documents.insurance.type.israel_student":
    "Израильская студенческая страховка",
  "patient.documents.insurance.type.israel_foreign_worker":
    "Израильская страховка иностранного работника",
  "patient.documents.insurance.type.israel_international_private":
    "Израильская международная частная страховка",
  "patient.documents.insurance.type.statutory_public_health":
    "Государственное медицинское покрытие",
  "patient.documents.insurance.type.social_health_fund":
    "Социальная больничная касса",
  "patient.documents.insurance.type.supplementary_health_plan":
    "Дополнительный медицинский план",
  "patient.documents.insurance.type.commercial_private_health":
    "Коммерческая частная медстраховка",
  "patient.documents.insurance.type.employer_group_health":
    "Групповой план работодателя",
  "patient.documents.insurance.type.travel_health":
    "Медицинская travel-страховка",
  "patient.documents.insurance.type.student_health":
    "Студенческая медстраховка",
  "patient.documents.insurance.type.foreign_worker_health":
    "Медстраховка иностранного работника",
  "patient.documents.insurance.type.international_expat_health":
    "Международная или expat-страховка",
  "patient.documents.insurance.type.other_health_coverage":
    "Другое медицинское покрытие",
  "patient.documents.insurerName": "Страховщик",
  "patient.documents.planName": "Название плана",
  "patient.documents.policyNumber": "Номер полиса",
  "patient.documents.memberNumber": "Номер участника",
  "patient.documents.groupNumber": "Номер группы",
  "patient.documents.validFrom": "Действует с",
  "patient.documents.validTo": "Действует до",
  "patient.documents.status.prepared": "Подготовлено",
  "patient.documents.status.sent": "Ожидает подписи",
  "patient.documents.status.submitted": "Загружено, ждёт проверки клиникой",
  "patient.documents.status.accepted": "Принято",
  "patient.documents.status.rejected": "Отклонено",
  "patient.documents.status.revoked": "Отозвано",
  "patient.documents.public.title": "Подписать документ пациента",
  "medicalSheet.title": "Медицинский титульный лист",
  "medicalSheet.subtitle":
    "Карта одним взглядом: диагнозы, последние показатели и открытая работа — из разделов, которым они принадлежат",
  "medicalSheet.loading": "Читаем карту…",
  "medicalSheet.notReadable": "Недоступно этой учётной записи",
  "medicalSheet.recordsForbidden":
    "Эта учётная запись не может читать клинические записи, поэтому эта часть листа не показана.",
  "medicalSheet.statPatient": "Пациент",
  "medicalSheet.ageUnknown": "Возраст не указан",
  "medicalSheet.curatorNamed": "Куратор: {name}",
  "medicalSheet.curatorNone": "Куратор не назначен",
  "medicalSheet.statDiagnoses": "Активные диагнозы",
  "medicalSheet.diagnosesCaption": "Всего {total} · хронических {chronic}",
  "medicalSheet.statCases": "Открытые случаи",
  "medicalSheet.casesCaption": "Активные и запланированные",
  "medicalSheet.statStay": "Госпитализация",
  "medicalSheet.stayNone": "Нет",
  "medicalSheet.stayNoneCaption": "Текущей или плановой госпитализации нет",
  "medicalSheet.statLastVisit": "Последний приём",
  "medicalSheet.visitNone": "Нет",
  "medicalSheet.visitNoneCaption": "Приёмов не записано",
  "medicalSheet.statLaboratory": "Результаты вне нормы",
  "medicalSheet.laboratoryWindow": "За последние 90 дней",
  "medicalSheet.laboratoryCritical": "Критических: {count} · за 90 дней",
  "medicalSheet.laboratoryClear": "Отклонений нет",
  "medicalSheet.laboratoryNoResults": "Результатов пока нет",
  "medicalSheet.diagnosesTitle": "Диагнозы",
  "medicalSheet.diagnosesEmpty": "У пациента нет записанных диагнозов.",
  "medicalSheet.diagnosesFailed": "Не удалось прочитать диагнозы.",
  "medicalSheet.encounters": "Приёмы",
  "medicalSheet.vitalsTitle": "Последние витальные показатели",
  "medicalSheet.vitalsEmpty": "Витальные показатели не записаны.",
  "medicalSheet.vitalsFailed": "Не удалось прочитать витальные показатели.",
  "medicalSheet.laboratoryTitle": "Результаты, требующие внимания",
  "medicalSheet.laboratoryEmpty": "Результатов вне нормы нет.",
  "medicalSheet.laboratoryFailed": "Не удалось прочитать результаты анализов.",
  "medicalSheet.casesTitle": "Открытые случаи",
  "medicalSheet.casesEmpty": "Открытых случаев нет.",
  "medicalSheet.casesFailed": "Не удалось прочитать случаи.",
  "medicalSheet.staysTitle": "Госпитализации",
  "medicalSheet.staysEmpty": "Текущих и запланированных госпитализаций нет.",
  "medicalSheet.staysFailed": "Не удалось прочитать госпитализации.",
  "medicalSheet.encountersTitle": "Последние приёмы",
  "medicalSheet.encountersEmpty": "Приёмы не записаны.",
  "medicalSheet.encountersFailed": "Не удалось прочитать приёмы.",
  "medicalSheet.filesTitle": "Последние документы",
  "medicalSheet.filesEmpty": "Документов нет.",
  "medicalSheet.filesFailed": "Не удалось прочитать документы.",
  "medicalSheet.openRecords": "Все приёмы",
  "medicalSheet.openLaboratory": "Все результаты",
  "medicalSheet.openCases": "Все случаи",
  "medicalSheet.openStays": "Все госпитализации",
  "medicalSheet.openFiles": "Все файлы",
  "medicalSheet.undated": "Без даты",
  "medicalSheet.referenceRange": "Референсный интервал: {range}",

  "case.loading": "Загрузка случаев",
  "case.loadFailed": "Не удалось загрузить случаи.",
  "case.datesOutOfOrder": "Дата окончания наступает раньше даты начала.",
  "case.staleRevision":
    "Этот случай изменился в другом месте. Перезагрузите его, чтобы увидеть, что хранится сейчас, затем примените к нему своё изменение.",
  "case.transitionRefused":
    "Этот случай больше не в том статусе, который это позволяет.",
  "case.saveFailed": "Не удалось сохранить случай. Попробуйте ещё раз.",
  "case.gone": "Этот случай больше недоступен.",
  "case.unavailable": "Случаи сейчас недоступны.",
  "case.status.planned": "Запланирован",
  "case.status.active": "Активный",
  "case.status.completed": "Завершён",
  "case.status.cancelled": "Отменён",
  "case.sectionTitle": "Случаи",
  "case.sectionSubtitle":
    "Все случаи, зарегистрированные для этого пациента. Случай — это один эпизод помощи: он объединяет приёмы, записи и направления, которые к нему относятся.",
  "case.empty": "Случаев не зарегистрировано",
  "case.emptyDetail":
    "Для этого пациента ещё не зарегистрирована клиническая работа. Первый приём или запись ЭМК открывает первый случай.",
  "case.noMatches": "Ни один случай не соответствует текущим фильтрам",
  "case.columnTitle": "Случай",
  "case.columnCode": "Код",
  "case.columnCurator": "Куратор",
  "case.columnStatus": "Статус",
  "case.columnPeriod": "Период",
  "case.columnColour": "Цвет",
  "case.columnActions": "Действия",
  "case.noPeriod": "Нет дат",
  "case.transitionOn": "{action}: {title}",
  "case.periodRange": "{from} – {to}",
  "case.periodFrom": "С {from}",
  "case.periodUntil": "По {to}",
  "case.new": "Новый случай",
  "case.edit": "Изменить случай",
  "case.editNamed": "Изменить случай {name}",
  "case.openNamed": "Открыть случай {name}",
  "case.title": "Название",
  "case.comment": "Комментарий",
  "case.startDate": "Дата начала",
  "case.endDate": "Дата окончания",
  "case.create": "Создать случай",
  "case.save": "Сохранить случай",
  "case.titleRequired": "Случаю нужно название.",
  "case.reload": "Перезагрузить этот случай",
  "case.reloaded":
    "Перезагружено с сервера. Проверьте изменения и сохраните снова.",
  "case.reloadFailed":
    "Не удалось загрузить сохранённую редакцию. Ваши изменения на месте.",
  "case.unsavedIntent": "Данные случая",
  "case.activate": "Активировать",
  "case.complete": "Завершить",
  "case.cancelCase": "Отменить случай",
  "case.colour": "Цвет",
  "case.colourNone": "Без цвета",
  "case.colour.red": "Красный",
  "case.colour.orange": "Оранжевый",
  "case.colour.green": "Зелёный",
  "case.colour.teal": "Бирюзовый",
  "case.colour.blue": "Синий",
  "case.colour.purple": "Фиолетовый",

  "stay.sectionTitle": "Госпитализации",
  "stay.independent":
    "Госпитализации самостоятельны. Они не группируются по случаям.",
  "stay.loading": "Загрузка госпитализаций…",
  "stay.loadFailed": "Не удалось загрузить госпитализации.",
  "stay.empty": "Госпитализаций не зарегистрировано",
  "stay.emptyDetail":
    "Здесь ничего не ожидается. Госпитализация записывается только тогда, когда она запланирована.",
  "stay.new": "Запланировать госпитализацию",
  "stay.create": "Создать госпитализацию",
  "stay.save": "Сохранить госпитализацию",
  "stay.cancelEditor": "Отменить изменения",
  "stay.unsavedIntent": "План госпитализации",
  "stay.editNamed": "Изменить план госпитализации в {facility}",
  "stay.transitionOn": "{action}: {facility}",
  "stay.facility": "Учреждение",
  "stay.facilityRequired": "Укажите учреждение перед сохранением.",
  "stay.wardBedNote": "Примечание об отделении или койке (необязательно)",
  "stay.plannedAdmission": "Плановая госпитализация (время клиники)",
  "stay.plannedDischarge": "Плановая выписка (время клиники)",
  "stay.timesRequired": "Введите оба плановых времени перед сохранением.",
  "stay.timesOutOfOrder":
    "Плановая выписка должна быть позже плановой госпитализации.",
  "stay.plannedWindow": "Планируется:",
  "stay.actualAdmission": "Госпитализирован:",
  "stay.actualDischarge": "Выписан:",
  "stay.admit": "Госпитализировать",
  "stay.discharge": "Выписать",
  "stay.cancelStay": "Отменить госпитализацию",
  "stay.status.planned": "Запланирована",
  "stay.status.admitted": "Госпитализирован",
  "stay.status.discharged": "Выписан",
  "stay.status.cancelled": "Отменена",
  "stay.staleRevision":
    "Эта госпитализация изменилась в другом месте. Перезагрузите её перед действием.",
  "stay.reload": "Перезагрузить эту госпитализацию",
  "stay.reloaded":
    "Перезагружено с сервера. Проверьте госпитализацию и повторите действие.",
  "stay.reloadFailed":
    "Не удалось загрузить сохранённую редакцию. Ваши изменения на месте.",
  "stay.transitionRefused":
    "Эта госпитализация больше не в том состоянии, которое позволяет это действие.",
  "stay.gone": "Эта госпитализация больше недоступна.",
  "stay.unavailable": "Госпитализации сейчас недоступны. Попробуйте ещё раз.",
  "stay.saveFailed": "Не удалось сохранить госпитализацию. Попробуйте ещё раз.",
};
